import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-clientes-proveedor',
  templateUrl: './clientes-proveedor.component.html',
  styleUrls: ['./clientes-proveedor.component.css']
})

export class ClientesProveedorComponent implements OnInit {

  
  
  url:string;
  urlSafe: SafeResourceUrl;
  
    constructor(public sanitizer: DomSanitizer) { }
  
    ngOnInit() {
      this.url=environment.apiReportes+"persona.rptdesign&idEmisor="+localStorage.getItem('id');
      this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
   
    }

}



